declare var jQuery: any;

/**
 * Add the notice
 *
 * @param DOM - The DOM object.
 * @return void
 */
function addSuccessNotice(DOM: any) {
  const { label, logo_url, dataagent_dashboard_url, post_edit_url } = (<any>window).DATAAGENT_SITE_KIT;
  const { post_id } = (<any>window).DATAAGENT_SITE_KIT.data;

  // Add custom card before #key-metrics.
  const dataagentCard = `
      <div id="dataagent-analyze-notice" class="dataagent-container">
        <div style="background-color: white; border-radius: 0.5rem; padding: 1.5rem; display: flex; align-items: center; border: 1px solid #e5e7eb;">
          <a href="${post_id ? `${post_edit_url}${post_id}` : dataagent_dashboard_url}" style="display: flex; align-items: center; text-decoration: none;">
            <img src="${logo_url}" style="margin-right: 1rem; width: 80px; height: 100%;">
            <div style="flex: 1;">
              <h3 style="font-size: 1.125rem; font-weight: 500; color: #111827; margin-bottom: 0.25rem;">${label.title}</h3>
              <p style="font-size: 0.75rem; color: #6b7280; margin: 0;">${label.description}</p>
            </div>
          </a>
        </div>
      </div>
    `;

  DOM.prepend(dataagentCard); 
}

/**
 * Analyze site traffic
 *
 * @return void
 */
async function analyzeSiteTraffic() {
  try {
    // Load Google Site Kit.
    const { googlesitekit } = <any>window;
    const currentYear = new Date().getFullYear();
    const currentDate = new Date().toISOString().split('T')[0];
    const { nonce, rest_api } = (<any>window).DATAAGENT_SITE_KIT;
    const { google_site_kit_traffic } = (<any>window).DATAAGENT_SITE_KIT.data;
    const startDate = typeof google_site_kit_traffic === 'object' && Object.keys(google_site_kit_traffic).length > 0 ? 
      Object.keys(google_site_kit_traffic)[Object.keys(google_site_kit_traffic).length - 1] : 
      `${currentYear}-01-01`;

    // Remove the last item from google_site_kit_traffic transient.
    // We do it this way because there is a chance when the report is generated, the data is not yet available.
    // For example, if the report is generated at 15:00, then the data > 15:00 is not yet available.
    // So we need to remove the last item from the transient to avoid using the old data.
    if (google_site_kit_traffic && typeof google_site_kit_traffic === 'object' && Object.keys(google_site_kit_traffic).length > 0) {
      delete google_site_kit_traffic[startDate];
    }

    // Get report params
    const reportParams = {
      metrics: [
        {
          name: 'totalUsers',
        },
      ],
      startDate,
      endDate: currentDate,
      dimensions: ['date'],
    };

    // Call the endpoint:
    const { rows } = await googlesitekit.api.get('modules', 'analytics-4', 'report', reportParams);

    // If rows is empty, return
    if (!rows) {
      return;
    }

    // Transform the data.
    let data = {};
    rows.forEach((item: any) => {
      data[item.dimensionValues[0].value.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')] = item.metricValues[0].value;
    });

    // Merge data if exists.
    if (google_site_kit_traffic) {
      data = { ...google_site_kit_traffic, ...data };
    }

    // Store the data in the database.
    fetch(rest_api, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': nonce,
      },
      body: JSON.stringify({
        type: 'traffic',
        data: data,
      }),
    });

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}

/**
 * Analyze single post traffic
 *
 * @param permaLink - The permalink of the post to analyze.
 * @return void
 */
async function analyzeSinglePostTraffic( permaLink: string ) {
  try {
    // Load Google Site Kit. 
    const { googlesitekit } = <any>window;
    const currentYear = new Date().getFullYear();
    const currentDate = new Date().toISOString().split('T')[0];
    const { nonce, rest_api } = (<any>window).DATAAGENT_SITE_KIT;
    const { post_id, google_site_kit_traffic_single_post } = (<any>window).DATAAGENT_SITE_KIT.data;
    const startDate = typeof google_site_kit_traffic_single_post === 'object' && Object.keys(google_site_kit_traffic_single_post).length > 0 ? 
      Object.keys(google_site_kit_traffic_single_post)[Object.keys(google_site_kit_traffic_single_post).length - 1] : 
      `${currentYear}-01-01`;

    // Remove the last item from google_site_kit_traffic transient.
    // We do it this way because there is a chance when the report is generated, the data is not yet available.
    // For example, if the report is generated at 15:00, then the data > 15:00 is not yet available.
    // So we need to remove the last item from the transient to avoid using the old data.
    if (google_site_kit_traffic_single_post && typeof google_site_kit_traffic_single_post === 'object' && Object.keys(google_site_kit_traffic_single_post).length > 0) {
      delete google_site_kit_traffic_single_post[startDate];
    }

    // Get report params
    const reportParams = {
      url: permaLink,
      metrics: [
        {
          name: 'totalUsers',
        },
      ],
      startDate,
      endDate: currentDate,
      dimensions: ['date'],
    };

    // Call the endpoint:
    const { rows } = await googlesitekit.api.get('modules', 'analytics-4', 'report', reportParams);

    // If rows is empty, return
    if (!rows) {
      return;
    }

    // Transform the data.
    let data = {};
    rows.forEach((item: any) => {
      data[item.dimensionValues[0].value.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')] = item.metricValues[0].value;
    });

    // Merge data if exists.
    if (google_site_kit_traffic_single_post) {
      data = { ...google_site_kit_traffic_single_post, ...data };
    }

    // Store the data in the database.
    fetch(rest_api, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': nonce,
      },
      body: JSON.stringify({
        type: 'traffic',
        post_id: post_id,
        data: data,
      }),
    });

    return true;
  } catch (error) {
    console.error(error); 
    return false;
  }
}

/**
 * Execute function when document is ready
 *
 * @return void
 */
jQuery(document).ready(async function ($) {
  let successAnalyzing = [];

  // Analyze site traffic.
  // @ts-ignore
  // successAnalyzing.push(await analyzeSiteTraffic()); // Dashboard DataAgent not support yet.

  // Get query parameter permaLink.
  let permaLink = window.location.search.split('permaLink=')[1] || null;
      permaLink = permaLink ? decodeURIComponent(permaLink) : null;
  if(permaLink){ 
    // @ts-ignore
    successAnalyzing.push(await analyzeSinglePostTraffic(permaLink));
  }

  // Add notice if analyze is successful.
  if(successAnalyzing.every(success => success)){
    // const DOM = permaLink ? jQuery('#js-googlesitekit-entity-dashboard') : jQuery('#js-googlesitekit-main-dashboard');
    // addSuccessNotice(DOM);
    // Dashboard DataAgent not support yet.
    if (permaLink){
      const DOM = jQuery('#js-googlesitekit-entity-dashboard');
      addSuccessNotice(DOM);
    }

    
  } else {
    jQuery('#dataagent-analyze-notice').remove(); 
  }
});
